module.exports = __webpack_public_path__ + "static/Video1Poster-fa81ca8f46d37fe0fb8a3bf30f3022e9.jpg";